module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "managementPage"
    }
  }, [_c('div', {
    staticClass: "side-menu"
  }, [_c('p', [_vm._v("メニュー")]), _vm._v(" "), _c('ul', {
    staticClass: "side-menu-items"
  }, [_c('router-link', {
    attrs: {
      "to": "/management/users",
      "tag": "li"
    }
  }, [_vm._v("\n        ユーザー一覧\n      ")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/management/user_registration",
      "tag": "li"
    }
  }, [_vm._v("\n        ユーザー登録\n      ")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/management/lecture_registration",
      "tag": "li"
    }
  }, [_vm._v("\n        講義情報編集\n      ")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/management/classroom_registration",
      "tag": "li"
    }
  }, [_vm._v("\n        教室情報編集\n      ")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/management/reschedulings",
      "tag": "li"
    }
  }, [_vm._v("\n        振替依頼一覧\n      ")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/management/information",
      "tag": "li"
    }
  }, [_vm._v("\n        お知らせ\n      ")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/management/InformationNotification",
      "tag": "li"
    }
  }, [_vm._v("\n        通知\n      ")])], 1)]), _vm._v(" "), _c('router-view', {
    staticClass: "child-component"
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-04a074d6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04a074d6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ManagementPage/ManagementPage.vue
// module id = 669
// module chunks = 0